export default __webpack_public_path__ + "static/client-garde-7d52aa49f759979dc483c39890cdbee4.png";